import React, { useEffect, useState } from "react";
import { Cascader } from "antd";
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from "recoil";
import { fetchCategoryList } from 'Services/inventory.services';
import { categoryAtom } from 'Recoil/inventory.atom';
import { isNil, filter, isEmpty, uniqueId } from 'lodash';
import { encode } from 'Helpers/enc';
import { generateCategoryTree } from 'Helpers/generate-categories-tree-v2';

import './category.scss';

const CategorySelect = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const [categoryState, setCategoryState] = useRecoilState<any>(categoryAtom);
    const [categoryOptions, setCategoryOptions] = useState<any> ([]);

  //this is to customise the dropdown component
  const dropdownRender = (menus: React.ReactNode) => (
    <div className="dropdown-style">
      {menus}
    </div>
  );

    const id = uniqueId('cascader--dropdown-');

    const handleFetchList = async () =>{
        setCategoryState({
            ...categoryState,
            status: { ...categoryState.status, fetch: 'loading' }
          });

        const responseData = await fetchCategoryList({
          active: true,
          level: [1, 2, 3]
        });

        if (!isNil(responseData) && responseData.length) {
            let filteredCategories=filter(responseData,categoryObj=>{
                return categoryObj.level <= 3;
            })
            let options = generateCategoryTree(filteredCategories)
            setCategoryOptions(options);
        }
        else {
            setCategoryState({
              ...categoryState,
              status: { ...categoryState.status, fetch: 'error' }
            });
          }
    }

    useEffect(()=>{
        handleFetchList();
    },[]);

    return (
      <React.Fragment>
      {!isEmpty(categoryOptions) ?
        <div className="category-menu">
          <Cascader
            className="cascade"
            getPopupContainer={() => document.getElementById(id) || document.body}
            bordered={false}
            options={categoryOptions}
            expandTrigger="hover"
            placeholder={''}
            dropdownRender={dropdownRender}
            size="large"
            changeOnSelect={true}
            allowClear={true}
            displayRender={() => t('alt.category')}
            onChange={(value: any, selectedOptions: any) => {
                let id=value.at(-1)
                let name=selectedOptions?.slice(-1)['0'].label
                history.push('/products/catalog/list?name='+encode(name)+'&category='+encode(id))
            }}
          />

          <div id={id} className="cascader--dropdown"></div>

        </div>
        : null
      }
    </React.Fragment>
    )
}

export default CategorySelect;

